import jamalPic from "@/public/images/artists/jamal.png";
import { Artist } from "@/types/types";

export const jamal = {
  id: "249",
  name: "Jamal",
  image: jamalPic,
  description: `Jamal's voice is airy and nasal, carrying a lazy, melancholy drawl. His delivery stays calm and unforced—flat and detached when rapping, gentle and melodic when singing.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjamal-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Hip Hop"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 47,
        high: 64,
      },
      sweetSpot: 54,
    },
  },
} as const satisfies Artist;
